module.exports = __webpack_public_path__ + "media/images/login_as-77401ee13dee32b20212e0e599c70067.png";